<template>
    <div class="row justify-content-between gy-3">
        <div class="col-12 col-md-3 mb-3 mb-md-0 d-flex justify-content-center align-items-center">
            <PrismicImage
                :img="document.data.logo"
                h="60"
                class="w-100 max-wpx-150 object-fit-contain"
            />
        </div>
        <div v-if="columnData.length > 0" class="col-12 col-md-6 d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2 gap-md-0 max-wpx-300 max-wpx-md-500 mx-auto">
            <div 
                v-for="(data, index) in columnData" 
                :key="index" 
                class="d-flex flex-md-column justify-content-between justify-content-md-center align-items-center gap-3 gap-md-0"
            >
                <span>{{ data.header }}</span>
                <span class="fw-bold">
                    {{ data.value }}
                </span>
            </div>
        </div>
        <div v-if="document" class="col-12 col-md-3 d-flex align-items-center">
            <out-link
                class="btn btn-primary w-100" 
                :document="document" 
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        },
        columnData: {
            type: Array,
            required: true
        }
    },        
};
</script>